<template>
  <div class="section">
    <div class="toolbar">
      <div class="section-title">应收付单据</div>
      <span>单据号</span>
      <el-input
        placeholder="单据号"
        v-model="filterDocNo"
        style="width:250px"
        size="small"
        clearable
        @keyup.enter.native="handleSearch"
      ></el-input>
      <span>业务类型</span>
      <el-select
        v-model="filterBizType"
        multiple
        collapse-tags
        style="width:250px"
        placeholder="业务类型"
        size="small"
        clearable
      >
        <el-option v-for="item in billtypeList" :label="item.name" :value="item.code" :key="item.code" />
      </el-select>
      <el-button type="primary" size="small" icon="el-icon-search" @click="handleSearch">查询</el-button>
      <el-button size="small" icon="el-icon-refresh" @click="handleReset">重置</el-button>
      <!-- <el-button size="small" type="warning" icon="el-icon-download" @click="handleExport">导出</el-button> -->
    </div>
    <el-table :data="displayData" border stripe size="small">
      <el-table-column label="序号" width="60" type="index" fixed></el-table-column>
      <el-table-column prop="billDate" label="业务日期" min-width="110"></el-table-column>
      <el-table-column prop="billPurchaseNo" label="业务单号" min-width="200"></el-table-column>
      <el-table-column prop="amountIn" label="应收" min-width="100">
        <template v-slot="scope">
          <span>￥{{ scope.row.amountIn }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="amountOut" label="应付" min-width="100">
        <template v-slot="scope">
          <span>￥{{ scope.row.amountOut }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="businessType" label="业务类型" min-width="120"></el-table-column>
      <el-table-column prop="createDate" label="制单时间" min-width="160"></el-table-column>
      <el-table-column prop="remarks" label="业务备注" show-overflow-tooltip min-width="200"></el-table-column>
      <el-table-column prop="remoteOrderNo" label="订单号" min-width="200"></el-table-column>
    </el-table>
  </div>
</template>

<script>
import { billTypes } from "@/api/reconciliation";
export default {
  name: "ReceivableSection",
  props: {
    orderInfo: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      filterDocNo: "",
      filterBizType: [],
      // 保存原始数据
      originalData: [],
      // 当前显示的数据（经过过滤）
      displayData: [],
      billtypeList: []
    };
  },
  computed: {
    // 应收合计
    totalAmountIn() {
      return this.displayData
        .reduce((sum, item) => {
          return sum + (Number(item.amountIn) || 0);
        }, 0)
        .toFixed(2);
    },
    // 应付合计
    totalAmountOut() {
      return this.displayData
        .reduce((sum, item) => {
          return sum + (Number(item.amountOut) || 0);
        }, 0)
        .toFixed(2);
    }
  },
  watch: {
    orderInfo: {
      handler(val) {
        if (val && val.data) {
          // 保存原始数据的副本
          this.originalData = JSON.parse(JSON.stringify(val.data));
        } else {
          this.originalData = [];
        }
        // 数据更新后自动显示全部（相当于重置显示）
        this.displayData = [...this.originalData];
        // 重置筛选条件
        this.filterDocNo = "";
        this.filterBizType = [];
      },
      immediate: true,
      deep: true
    }
  },
  mounted() {
    this.getBillTypes();
  },
  methods: {
    //获取来源类型
    getBillTypes() {
      billTypes().then(res => {
        this.billtypeList = res || [];
      });
    },
    // 查询
    handleSearch() {
      // 从原始数据中过滤
      this.displayData = this.originalData.filter(item => {
        // 单据号过滤
        let matchDocNo = true;
        if (this.filterDocNo && this.filterDocNo.trim()) {
          const keyword = this.filterDocNo.trim();
          matchDocNo =
            (item.billPurchaseNo && item.billPurchaseNo.includes(keyword)) ||
            (item.remoteOrderNo && item.remoteOrderNo.includes(keyword));
        }

        // 业务类型过滤
        let matchBizType = true;
        if (this.filterBizType && this.filterBizType.length > 0) {
          matchBizType = this.filterBizType.includes(item.billType);
        }
        return matchDocNo && matchBizType;
      });
    },

    // 重置
    handleReset() {
      this.filterDocNo = "";
      this.filterBizType = [];
      // 重置为显示全部数据
      this.displayData = [...this.originalData];
    },

    // 导出
    handleExport() {
      if (this.displayData.length === 0) {
        this.$message.warning("当前没有数据可导出");
        return;
      }

      // 导出逻辑
      console.log("导出数据：", this.displayData);
      this.$message.success(`成功导出 ${this.displayData.length} 条数据`);

      // 实际导出代码示例（需要安装 xlsx 库）
      // import XLSX from 'xlsx';
      // const exportData = this.displayData.map(item => ({
      //   '业务日期': item.billDate,
      //   '业务单号': item.billPurchaseNo,
      //   '应收': item.amountIn,
      //   '应付': item.amountOut,
      //   '业务类型': item.businessType,
      //   '制单时间': item.createDate,
      //   '业务备注': item.remarks,
      //   '订单号': item.remoteOrderNo
      // }));
      // const ws = XLSX.utils.json_to_sheet(exportData);
      // const wb = XLSX.utils.book_new();
      // XLSX.utils.book_append_sheet(wb, ws, '应收单据');
      // XLSX.writeFile(wb, `应收单据_${this.getCurrentTime()}.xlsx`);
    },

    // 获取当前时间字符串（用于导出文件名）
    getCurrentTime() {
      const now = new Date();
      return `${now.getFullYear()}${String(now.getMonth() + 1).padStart(2, "0")}${String(now.getDate()).padStart(
        2,
        "0"
      )}_${String(now.getHours()).padStart(2, "0")}${String(now.getMinutes()).padStart(2, "0")}`;
    }
  }
};
</script>

<style scoped>
.section {
  margin-bottom: 30px;
  border-bottom: 1px solid #ebeef5;
  padding-bottom: 24px;
}
.section-title {
  font-size: 16px;
  font-weight: 700;
  color: #333333;
}
.toolbar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px 16px;
  background: rgb(249, 249, 249);
  padding: 12px 16px;
}
.toolbar .el-input,
.toolbar .el-select {
  width: 160px;
}
.table-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 16px;
  background: #f5f7fa;
  border: 1px solid #ebeef5;
  border-top: none;
  font-size: 14px;
  color: #606266;
}
.summary-amount {
  font-weight: 600;
  color: #303133;
}
</style>
